<template>
  <div class="modal__offer">
    <img :src="mediaBaseUrl + 'after-quiz/timeout2.png'" alt="">
    <div class="bg"></div>

    <div class="modal-offer__content">
      <h2>Are you sure you want to lose your personalized plan?</h2>

      <h3>We have prepared for you:</h3>
      <div class="benefits">
        <div v-for="benefit in benefits" :key="benefit" class="benefit">
          <img :src="mediaBaseUrl + 'after-quiz/benefit-marker.svg'" alt="marker">
          <p>{{benefit}}</p>
        </div>
      </div>

      <div class="offer__actions">
        <custom-button @click="handleReject">
          Lose all the benefits
        </custom-button>

        <custom-button @click="$emit('changeModal', 'payment')" :secondary="true">
          Start Free Trial
        </custom-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",

  inject: ["mediaBaseUrl"],

  data() {
    return {
      benefits: [
        "More than 100 workouts for you!",
        "Measuring heart rate, blood oxygen & pressure",
        "Hundreds of healthy recipes for every day food",
      ],
    };
  },

  methods: {
    handleReject() {
      this.$emit("close");
      this.$router.push('/');
    }
  },
}
</script>

<style lang="sass" scoped>
@import '../../../sass/variables'

.modal__offer
  display: flex
  flex-direction: column
  align-items: center
  justify-content: flex-end
  position: relative
  max-height: 80vh
  height: 640px
  max-width: 508px
  width: 100%
  padding: 56px 33px
  border-radius: 16px
  overflow: hidden

  & > img
    top: 0
    left: 0
    position: absolute
    width: 100%

  .bg
    position: absolute
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 60.5%, #000000 100%)
    width: 100%
    height: 100%
    bottom: 0
    left: 0

  .modal-offer__content
    z-index: 1

    .offer__actions
      display: flex
      flex-direction: column-reverse
      flex-wrap: wrap
      gap: 16px
      justify-content: center

      .button
        &:first-child
          padding: 14px 40px
          border: none
          background: rgba(255, 255, 255, 0.1)

          &:hover
            color: rgba(255, 255, 255, .6)

      @media screen and (min-width: $lg)
        flex-direction: row
        gap: 8px
        justify-content: space-between

    h3
      font-size: 1.125rem
      line-height: 1.125rem
      font-weight: 900
      text-align: center
      margin-top: 24px
      color: #ffffff

      @media screen and (min-width: $lg)
        font-size: 1.25rem
        line-height: 1.25rem

    .benefits
      display: flex
      flex-direction: column
      align-items: flex-start
      margin: 16px 0 24px

    .benefit
      display: flex
      align-items: center
      margin-bottom: 14px

      p
        margin-left: 8px
        font-size: 1.125rem
        line-height: 1.125rem
        font-weight: 500
        color: #ffffff

      &:last-child
        margin-bottom: 0

    h2
      font-size: 2rem
      line-height: 2.125rem
      color: #ffffff
      font-weight: 900
      text-align: center

    .button
      margin: 0 auto
</style>
